import { Container, Col, Row } from "reactstrap";
import * as PointQL from "queries/point-limit";
import { Link } from "react-router-dom";
import { List } from "@repoflow/components/list-cursor";
import PointLimitSchema from "@common/schema/point-limit/public";
import * as widgets from "widgets/register";
import * as Section from "@repoflow/components/section";

export const Sidebar = () => null;

export const Indice = () => null;

export const Content = ({ match: { params } }) => {
  const { base } = Section.useSectionContext();

  return (
    <Container>
      <div className="mt-4"></div>

      <Row>
        <Col>
          <Link className={"btn btn-primary"} to={`${base}/new`}>
            <i className="fa fa-plus" /> Add
          </Link>
        </Col>
      </Row>

      <div className="mt-4"></div>

      <List
        path={"viewer.account.points.get.limits"}
        query={PointQL.list}
        variables={params}
        schema={PointLimitSchema}
        widgets={widgets}
        target={{ $ref: "/Public/PointLimit" }}
        empty={"No limits yet."}
        config={{
          "/Public/PointLimit": {
            fields: ["limitId", "description", "dimensions", "limits", "updatedAt"],
          },
        }}
        content={({ item: { limitId } }) => (
          <>
            <Link className={"btn btn-primary"} to={`${base}/${limitId}/`}>
              View
            </Link>{" "}
          </>
        )}
      />
    </Container>
  );
};
